"use client";

import { c as _c } from "react/compiler-runtime";
import { LanguageIcon } from "@/components/mdx/language-icon";
import { CopyIconButton } from "@/components/ui/copy-icon-button";
export function CodeBlockHeader(t0) {
  const $ = _c(14);
  const {
    filename,
    language,
    code
  } = t0;
  let t1;
  if ($[0] !== filename || $[1] !== language) {
    t1 = <LanguageIcon filename={filename} language={language} />;
    $[0] = filename;
    $[1] = language;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== filename) {
    t2 = <span className="truncate font-berkeley-mono text-[13px] text-gray-1100">{filename}</span>;
    $[3] = filename;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex min-w-0 items-center gap-2">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      name: "Code Copied",
      properties: {
        source: "code-block"
      }
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== code) {
    t5 = <CopyIconButton className="size-7 rounded-md" event={t4} iconClassName="size-4" label="Copy code" text={code} />;
    $[9] = code;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="flex items-center justify-between gap-2 border-preview-border border-b bg-gray-100 py-1.5 pr-1.5 pl-3">{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}